import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  Grid,
  Typography,
  useMediaQuery,
  CircularProgress,
  TextField,
  Checkbox,
  Box,
  InputAdornment,
} from "@mui/material";
import "./styles.scss";
import Select from "react-select";
import { useFormik } from "formik";
import Button from "@mui/material/Button";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { apiUrl } from "../../constants";
import PaymentButton from "./payment";
import { scrollToTop } from "../../utils";
import Packagecard from "./packagescard";
import {
  validateEmail,
  validatePhoneNumber,
  validateAge,
} from "../../utils/validators/validate";
import {
  addPackages,
  addPersons,
  removePersons,
} from "../../utils/store/slice/userSlice";
import { getDiscount } from "../../actions/ticket";
import { useNavigate } from "react-router-dom";
import Ticket from "./ticket";
import MoneyBg from "../../assets/money-logo-bg.svg";
import Bg from "./images/bookNowBg.jpg";
import CouponModal from "./Coupon";
export const genderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "others", label: "Others" },
];

const initialValues = {
  id: "",
  name: "",
  email: "",
  phone: "",
  age: "",
  gender: "",
  price: "",
  package: "",
  freebies: "",
  date: null,
  time: "",
  extra_red: 0,
  extra_green: 0,
  extra_yellow: 0,
  golden_flag: 0,
  funingocoins: 0,
  totalfuningocoinsassigned: 0,
  count: 1,
  isChecked: false,
  coins: 0,
};

const initialErrorMsg = {
  name: "",
  email: "",
  phone: "",
  age: "",
  gender: "",
  price: "",
  package: "",
  freebies: "",
  funingocoins: "",
  totalfuningocoinsassigned: "",
  error: false,
};

const Booknow = () => {
  const dispatch = useDispatch();

  const {
    userData = {},
    token,
    isPremium,
  } = useSelector((store) => store.userSlice);
  const packagesData = useSelector((store) => store.userSlice.packagesData);
  const packageMap = useSelector((store) => store.userSlice.packageMap);
  const personsList = useSelector((store) => store.userSlice.personList);
  const isLoggedIn = useSelector((store) => store.userSlice.isLoggedIn);
  const isMobile = useMediaQuery("(max-width:900px)");
  const [persons, setPersons] = useState([]);
  const [personsData, setPersonsData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(initialErrorMsg);
  const [totalPrice, setTotalPrice] = useState(0);
  const [couponDiscount, setCouponDiscount] = useState({});
  const [code, setCode] = useState("");
  const [showTrampolinePopup, setShowTrampolinePopup] = useState(false);
  const [premium50Live, setPremium50Live] = useState(0);
  const [premium100Live, setPremium100Live] = useState(0);
  const [selectedPremium, setSelectedPremium] = useState(null);
  const [usedFuningoMoney, setUseFuningoMoney] = useState(0);
  const [totalPremiumDiscount, setTotalPremiumDiscount] = useState(0);
  const [weekdayPackage, setWeekdayPackage] = useState(false);
  const [disablevar, setdisablevar] = useState(false);
  const [isTimeSelected, setIsTimeSelected] = useState(false);
  const [regularPackagePrice, setRegularPackagePrice] = useState();
  const [regularPackageId, setRegularId] = useState();
  const [regularPackageCoin, setRegularPackageCoin] = useState();
  const [showTicket, setShowTicket] = useState({ show: false, data: null });
  const [selectedUnlimitedPackages, setSelectedUnlimitedPackages] = useState(
    [],
  );

  const navigate = useNavigate();

  // New state for activities
  const [activities, setActivities] = useState([]);
  const [isLoadingActivities, setIsLoadingActivities] = useState(false);

  const today = new Date().getDay();
  const isWeekend = today === 0 || today === 6;

  const [currentPackageIndex, setCurrentPackageIndex] = useState(0);
  const [unlimitedPackages, setUnlimitedPackages] = useState([]);
  const [isCouponModalOpen, setIsCouponModalOpen] = useState(false);

  const generateUniqueShortId = () => {
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const alphanumeric = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    const firstChar = alphabets[Math.floor(Math.random() * alphabets.length)];

    let remainingChars = "";
    for (let i = 0; i < 4; i++) {
      remainingChars +=
        alphanumeric[Math.floor(Math.random() * alphanumeric.length)];
    }

    return firstChar + remainingChars;
  };

  const getCurrentDay = () => {
    const days = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    const today = new Date().getDay();
    return days[today];
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  const fetchUnlimtedPackages = async () => {
    try {
      const response = await axios.get(`${apiUrl}/unlimitedPackage/packages`);
      const currentDay = getCurrentDay();

      const packages = response.data.data
        .filter((pkg) => pkg.selectedDays.includes(currentDay))
        .map((pkg) => ({
          id: pkg._id,
          name: pkg.packageName,
          price: pkg.totalCost,
          days: pkg.selectedDays,
          activities: pkg.activities,
          createdAt: pkg.createdAt,
        }));

      setUnlimitedPackages(packages);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };
  useEffect(() => {
    fetchUnlimtedPackages();
  }, []);

  const getSortedPackages = () => {
    const regularPackages = packagesData
      .filter((pkg) => pkg.name !== "special")
      .sort((a, b) => (a.coins || 0) - (b.coins || 0));

    const noneOption = {
      id: "none",
      name: "None",
      coins: 0,
      description: "No package selected",
    };

    return [noneOption, ...regularPackages];
  };

  const calculateUnlimitedPrice = () => {
    return selectedUnlimitedPackages.reduce((total, pkg) => {
      return total + pkg.price * pkg.count;
    }, 0);
  };

  const regularPackageCost = () => {
    let cost = getSortedPackages()[currentPackageIndex]?.price || 0;
    setRegularPackageCoin(getSortedPackages()[currentPackageIndex]?.coins || 0);
    return cost;
  };
  useEffect(() => {
    const sortedPackages = getSortedPackages();
    if (sortedPackages.length > 0) {
      setFieldValue("package", sortedPackages[0]._id);
      setFieldValue("coins", sortedPackages[0].coins || 0);
    }
  }, [packagesData]);

  useEffect(() => {
    setUseFuningoMoney(Number(values.totalfuningocoinsassigned));
  }, []);

  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const disablevariable = () => {
    setdisablevar(true);
  };

  let weekdaypackageprice = 0;

  const {
    values,
    setFieldValue,
    resetForm,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues,

    onSubmit: async (values) => {
      setErrorMsg(initialErrorMsg);
      if (values?.id.length === 0) values.id = generateUniqueShortId();
      let errmessage = "";
      try {
        if (!validateAge(values.age)) {
          setErrorMsg({
            ...errorMsg,
            age: "Invalid Age",
          });
          resetForm({
            values: {
              ...values,
              age: "",
            },
          });
          errmessage += "Invalid Age Entry ";
        }
        if (!validateEmail(values.email)) {
          setErrorMsg({
            ...setErrorMsg,
            email: "Email Address is invalid",
          });
          errmessage += "Email Address is invalid ";
        }

        if (!validatePhoneNumber(values.phone)) {
          setErrorMsg({
            ...setErrorMsg,
            phone: "Invalid Phone Number",
          });
          errmessage += "Invalid Phone Number";
        }

        if (
          Number(values.funingocoins) > userData?.funingo_money ||
          Number(values.funingocoins) < 0
        ) {
          setErrorMsg({
            ...setErrorMsg,
            funingocoins: "Invalid Funingo Coins",
          });
          errmessage += "Invalid Funingo Coins";
        }

        if (
          Number(values.totalfuningocoinsassigned) +
            Number(values.funingocoins) >
          userData?.funingo_money
        ) {
          setErrorMsg({
            ...setErrorMsg,
            totalfuningocoinsassigned: "Funingo Coins exceeded",
          });
          errmessage += "Funingo Coins exceeded";
        }

        if (errmessage.length !== 0) {
          throw new Error(errmessage);
        }

        if (errmessage.length == 0) {
          let weekdayprice = values.isChecked == true ? weekdaypackageprice : 0;
          values.extra_yellow =
            values.extra_yellow + Number(values.funingocoins);
          values.totalfuningocoinsassigned =
            Number(values.totalfuningocoinsassigned) +
            Number(values.funingocoins);
        }

        const pID = values?.package;
        setRegularId(pID);
        const pkgObj = packageMap?.[pID];

        const details = [];

        if (pID && pID !== "none") {
          details.push({
            package: pID,
            packageType: "regular",
            person_name: "",
            age: "",
            gender: "",
            unlimitedPackageData: null,
          });
        }

        // Add unlimited packages to details
        selectedUnlimitedPackages.forEach((unlimitedPkg, index) => {
          for (let i = 0; i < unlimitedPkg.count; i++) {
            details.push({
              package: null,
              packageType: "unlimited",
              person_name: "",
              age: "",
              gender: "",
              unlimitedPackageData: {
                name: unlimitedPkg.name,
                price: unlimitedPkg.price,
                activities: unlimitedPkg.activities,
                _id: unlimitedPkg.id,
              },
            });
          }
        });

        values = {
          ...values,
          price: pkgObj?.price ?? 0,
          selectedPremium,
          details: details,
        };
        setPersons([values]);
        setPersonsData(values);
        setSelectedPremium(null);
        return true;
      } catch (error) {
        console.log(error.message, error);
      }
    },
  });
  const getDiscountUsingCoupon = async () => {
    const resp = await getDiscount({
      token,
      code,
      total_amount: totalPrice - totalPremiumDiscount,
    });
    setCouponDiscount({ discount: resp.discount, message: resp.msg, code });
  };

  const handleCheckboxChange = () => {
    values.isChecked = !values.isChecked;
  };

  useEffect(() => {
    return () => {
      // Clear location state when leaving the component
      window.history.replaceState(null, "", window.location.pathname);
    };
  }, []);

  // Function to fetch activities from APi
  const fetchActivities = async () => {
    try {
      setIsLoadingActivities(true);
      const response = await axios.get(`${apiUrl}/activity/activityfetch`);

      if (response.data) {
        setActivities(response.data || []);
      } else {
        console.error("Failed to fetch activities:", response.data.message);
        setActivities([]);
      }
    } catch (error) {
      console.error("Error fetching activities:", error);
      setActivities([]);
    } finally {
      setIsLoadingActivities(false);
    }
  };

  const packageOptions = packagesData
    .map((packageObj) => {
      if (packageObj.name === "special") {
        weekdaypackageprice = packageObj.price;
        return null;
      }
      return {
        value: packageObj?._id,
        label: <Packagecard data={packageObj} boolFlag={true} />,
      };
    })
    .filter((option) => option !== null);

  const timeOptions = [
    { value: "11-12", label: "11 AM - 12 PM" },
    { value: "12-13", label: "12 PM - 01 PM" },
    { value: "13-14", label: "01 PM - 02 PM" },
    { value: "14-15", label: "02 PM - 03 PM" },
    { value: "15-16", label: "03 PM - 04 PM" },
    { value: "16-17", label: "04 PM - 05 PM" },
    { value: "17-18", label: "05 PM - 06 PM" },
    { value: "18-19", label: "06 PM - 07 PM" },
    { value: "19-20", label: "07 PM - 08 PM" },
    { value: "20-21", label: "08 PM - 09 PM" },
    { value: "21-22", label: "09 PM - 10 PM" },
  ];

  const handleSelectedPremiumChange = (event) => {
    setSelectedPremium((curr) => {
      if (curr?.premium_type === event.target.id) {
        if (curr?.premium_type === "50%") {
          setPremium50Live((cur) => [...cur, curr]);
        } else {
          setPremium100Live((cur) => [...cur, curr]);
        }
        return null;
      }
      return event.target.id === "50%" ? premium50Live[0] : premium100Live[0];
    });
  };

  const handleResetBookForm = () => {
    resetForm({ values: initialValues });

    // Reset all additional states
    setFieldValue("date", "");
    setFieldValue("count", 1);
    setCurrentPackageIndex(0);
    setSelectedUnlimitedPackages([]);
    setCouponDiscount({});
    setCode("");
    setUseFuningoMoney(0);
    setTotalPrice(0);
    setTotalPremiumDiscount(0);
    setSelectedPremium(null);
    setPersons([]);
    setPersonsData({});
    setErrorMsg(initialErrorMsg);

    // Reset to default package
    const sortedPackages = getSortedPackages();
    if (sortedPackages.length > 0) {
      setFieldValue("package", sortedPackages[0]._id);
      setFieldValue("coins", sortedPackages[0].coins || 0);
    }
    window.history.replaceState(null, "", window.location.pathname);
  };

  // unlimted manage
  const handleUnlimitedPackageAdd = (packageData) => {
    const existingPackage = selectedUnlimitedPackages.find(
      (pkg) => pkg.id === packageData.id,
    );

    if (existingPackage) {
      setSelectedUnlimitedPackages((prev) =>
        prev.map((pkg) =>
          pkg.id === packageData.id ? { ...pkg, count: pkg.count + 1 } : pkg,
        ),
      );
    } else {
      setSelectedUnlimitedPackages((prev) => [
        ...prev,
        { ...packageData, count: 1 },
      ]);
    }
    window.history.replaceState(null, "", window.location.pathname);
  };

  const handleUnlimitedPackageCountChange = (packageId, newCount) => {
    if (newCount <= 0) {
      setSelectedUnlimitedPackages((prev) =>
        prev.filter((pkg) => pkg.id !== packageId),
      );
    } else {
      setSelectedUnlimitedPackages((prev) =>
        prev.map((pkg) =>
          pkg.id === packageId ? { ...pkg, count: newCount } : pkg,
        ),
      );
    }
  };

  useEffect(() => {
    let total = 0;

    persons.forEach((person) => {
      total += person.price;
    }, []);

    total += calculateUnlimitedPrice() + regularPackageCost();

    if (isPremium) {
      setTotalPremiumDiscount(total / 2);
    }
    setTotalPrice(total);
  }, [persons, selectedUnlimitedPackages, getSortedPackages]);

  useEffect(() => {
    async function fetchData() {
      try {
        setIsLoading(true);
        const response = await axios.get(`${apiUrl}/package`);
        if (!response.data.success) {
          throw new Error("Couldn't Fetch Packages");
        }
        dispatch(addPackages(response.data.packages));
        setIsLoading(false);
      } catch (error) {
        console.error(error.message, error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchData();
    fetchActivities();

    if (personsList && personsList.length !== 0) {
      setPersons(personsList);
      setPersonsData(personsList[0]);
    }

    return () => {
      dispatch(removePersons());
      dispatch(addPersons(persons));
    };
  }, []);

  useEffect(() => {
    if (showTrampolinePopup) {
      const timeoutId = setTimeout(() => {
        setShowTrampolinePopup(false);
      }, 3000);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [showTrampolinePopup]);
  useEffect(() => {
    if (userData) {
      setPremium50Live(
        userData?.premium?.filter(
          (data) =>
            new Date(data.expires_on) > Date.now() &&
            data?.premium_type === "50%",
        ),
      );
      resetForm({
        values: {
          ...values,
          email: values.email
            ? values.email
            : userData?.email
              ? userData.email
              : "",
          phone: values.phone
            ? values.phone
            : userData?.phone_no
              ? userData.phone_no.split("-")?.[1]
              : "",
        },
      });
    }
  }, [userData]);

  // For mobile version of Charges Information
  const [isVisible, setIsVisible] = useState(false);
  const gridRef = useRef(null);
  // const nameRef = useRef(null);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const handleSubmitBookNow = () => {
    handleSubmit();
  };

  const handleClickOutside = (event) => {
    if (gridRef.current && !gridRef.current.contains(event.target)) {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // for coming from package page
  const location = useLocation();
  useEffect(() => {
    if (
      location.state?.selectedPackage &&
      packagesData.length > 0 &&
      !location.state?.isReset
    ) {
      const { id, type } = location.state.selectedPackage;

      if (type === "regular") {
        const packageIndex = getSortedPackages().findIndex(
          (pkg) => pkg._id === id,
        );
        if (packageIndex !== -1) {
          setCurrentPackageIndex(packageIndex);
          setFieldValue("package", id);
          setFieldValue("coins", getSortedPackages()[packageIndex].coins || 0);
        }
      }
    }
  }, [location.state, packagesData]);

  useEffect(() => {
    if (
      location.state?.selectedPackage &&
      unlimitedPackages.length > 0 &&
      !location.state?.isReset
    ) {
      const { id, type } = location.state.selectedPackage;

      if (type === "unlimited") {
        // Check if already selected to avoid duplicates
        const alreadySelected = selectedUnlimitedPackages.find(
          (pkg) => pkg.id === id,
        );

        if (!alreadySelected) {
          const unlimitedPkg = unlimitedPackages.find((pkg) => pkg.id === id);
          if (unlimitedPkg) {
            handleUnlimitedPackageAdd(unlimitedPkg);
          }
        }
      }
    }
  }, [unlimitedPackages, location.state?.selectedPackage]);

  // const scrollToNameField = () => {
  //   nameRef.current?.scrollIntoView({
  //     behavior: "smooth",
  //     block: "center",
  //   });
  //   nameRef.current?.focus();
  // };

  // function to prepare the final values before payment
  const prepareSubmissionValues = () => {
    const pID = values?.package;
    const pkgObj = packageMap?.[pID];

    // Create details array
    const details = [];

    // Add regular package to details
    if (pID && pID !== "none") {
      details.push({
        package: pID,
        packageType: "regular",
        unlimitedPackageData: null,
      });
    }

    selectedUnlimitedPackages.forEach((unlimitedPkg) => {
      for (let i = 0; i < unlimitedPkg.count; i++) {
        details.push({
          package: null,
          packageType: "unlimited",
          unlimitedPackageData: {
            name: unlimitedPkg.name,
            price: unlimitedPkg.price,
            activities: unlimitedPkg.activities,
          },
        });
      }
    });

    return {
      ...values,
      price: totalPrice,
      selectedPremium,
      details: details,
      regularPackageId,
      fun_date: new Date().toISOString(),
      short_id: generateUniqueShortId(),
      extra_yellow:
        (values.extra_yellow || 0) + Number(values.funingocoins || 0),
      totalfuningocoinsassigned:
        Number(values.totalfuningocoinsassigned || 0) +
        Number(values.funingocoins || 0),
    };
  };

  return (
    <Grid
      className="booknow"
      sx={{
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)",
          zIndex: 1,
        },
      }}
    >
      {isLoading && (
        <Grid
          className="loading-overlay"
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(0, 0, 0, 0.7)",
            backdropFilter: "blur(10px)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              background: "rgba(255, 255, 255, 0.1)",
              borderRadius: "20px",
              padding: "40px",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(20px)",
            }}
          >
            <CircularProgress
              sx={{
                color: "#00ff88",
                "& .MuiCircularProgress-circle": {
                  strokeLinecap: "round",
                },
              }}
            />
            <Typography
              sx={{
                color: "white",
                fontWeight: 600,
                fontSize: "18px",
                textAlign: "center",
              }}
            >
              Loading...
            </Typography>
          </Box>
        </Grid>
      )}

      {/* first box*/}
      <div className="relative h-[35vh] sm:h-[40vh] md:h-[50vh] lg:h-[60vh] flex items-center justify-center overflow-hidden mb-8 md:mb-12 px-4">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-contain bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${Bg})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
          }}
        ></div>

        {/* Yellow/Green Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-blue-400/60 via-blue-500/50 to-green-600/40"></div>

        {/* Heading */}
        <h1
          className="relative text-3xl sm:text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white tracking-wider z-10 text-center px-4 max-w-full break-words"
          style={{
            textShadow: "4px 4px 8px rgba(0,0,0,0.5), 0 0 20px rgba(0,0,0,0.3)",
            fontFamily: "Arial Black, sans-serif",
            letterSpacing: "0.05em",
            wordWrap: "break-word",
            hyphens: "auto",
          }}
        >
          Happy Adventuring
        </h1>
      </div>

      {showTicket.show && (
        <Ticket
          open={showTicket.show}
          onClose={() => setShowTicket(false)}
          isPremium={isPremium}
          ticket={showTicket.data}
        />
      )}

      <Grid
        className="top2 flex lg:justify-evenly lg:flex-row max-md:flex-col max-md:flex-wrap max-md:justify-center max-md:p-5"
        mb={"2%"}
        sx={{
          position: "relative",
          zIndex: 2,
          padding: { xs: "20px", md: "40px" },
          gap: "30px",
        }}
      >
        {/* Mobile button  */}
        <button
          onClick={toggleVisibility}
          className="
    z-50 h-10 text-[15px] lg:hidden
    flex items-center justify-center
    w-44 p-3 rounded-3xl
    bg-[#03ea2e] buttonText
    cursor-pointer
    mx-auto
    left-1/2 -translate-x-1/2
  "
          style={{
            position: "absolute",
            background: "linear-gradient(135deg, #00ff88 0%, #00cc6a 100%)",
            border: "none",
            boxShadow: "0 8px 32px rgba(0, 255, 136, 0.4)",
            transform: "translateX(-50%) translateY(0)",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            backdropFilter: "blur(10px)",
            fontWeight: 600,
            color: "white",
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "translateX(-50%) translateY(-2px)";
            e.target.style.boxShadow = "0 12px 40px rgba(0, 255, 136, 0.6)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateX(-50%) translateY(0)";
            e.target.style.boxShadow = "0 8px 32px rgba(0, 255, 136, 0.4)";
          }}
        >
          VIEW ACTIVITY COSTS
        </button>

        {/* Left Information Grid Mobile Version  */}
        {isVisible && (
          <Grid
            className={`bukFormMobile z-[500] absolute w-[100%] lg:hidden ${
              isVisible ? "slide-in" : "slide-out"
            }`}
            sx={{
              background: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(20px)",
              borderRadius: "20px",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              padding: "20px",
              boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
              animation: "slideIn 0.3s ease-out",
              "@keyframes slideIn": {
                from: { opacity: 0, transform: "translateY(-20px)" },
                to: { opacity: 1, transform: "translateY(0)" },
              },
            }}
          >
            {isLoadingActivities ? (
              <div className="flex flex-col justify-center items-center py-12">
                <CircularProgress size={40} sx={{ color: "#00ff88" }} />
                <Typography
                  className="mt-3"
                  sx={{ color: "white", fontWeight: 500, fontSize: "14px" }}
                >
                  Loading activities...
                </Typography>
              </div>
            ) : (
              <div className="space-y-3">
                {activities.map((activity, index) => {
                  const gradients = [
                    "linear-gradient(135deg, rgba(139, 92, 246, 0.95) 0%, rgba(168, 85, 247, 0.95) 100%)",
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.95) 0%, rgba(37, 99, 235, 0.95) 100%)",
                    "linear-gradient(135deg, rgba(236, 72, 153, 0.95) 0%, rgba(219, 39, 119, 0.95) 100%)",
                    "linear-gradient(135deg, rgba(34, 197, 94, 0.95) 0%, rgba(22, 163, 74, 0.95) 100%)",
                    "linear-gradient(135deg, rgba(249, 115, 22, 0.95) 0%, rgba(234, 88, 12, 0.95) 100%)",
                  ];

                  return (
                    <div
                      key={activity._id || index}
                      className="group relative overflow-hidden"
                      style={{
                        background: gradients[index % gradients.length],
                        borderRadius: "16px",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        cursor: "pointer",
                        minHeight: "72px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(-4px) scale(1.01)";
                        e.currentTarget.style.boxShadow =
                          "0 12px 35px rgba(0, 0, 0, 0.25)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform =
                          "translateY(0) scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 20px rgba(0, 0, 0, 0.15)";
                      }}
                    >
                      {/* Shimmer effect */}
                      <div
                        className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                        style={{
                          background:
                            "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
                          animation: "shimmer 2s infinite",
                        }}
                      />

                      <div className="relative flex items-center justify-between p-4">
                        {/* Left side - Activity name */}
                        <div className="flex items-center gap-3 flex-1 min-w-0">
                          <div
                            className="flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center"
                            style={{
                              background: "rgba(255, 255, 255, 0.2)",
                              backdropFilter: "blur(10px)",
                            }}
                          >
                            <span className="text-white text-lg font-bold">
                              {activity.name.charAt(0).toUpperCase()}
                            </span>
                          </div>

                          <div className="flex-1 min-w-0">
                            <h2
                              className="truncate"
                              style={{
                                fontWeight: 600,
                                color: "white",
                                fontSize: "15px",
                                lineHeight: "1.4",
                                textShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              {activity.name}
                            </h2>
                          </div>
                        </div>

                        {/* Right side - Coins */}
                        <div className="flex-shrink-0 ml-3">
                          <CoinsBox text={`${activity.coins_required || 0}`} />
                        </div>
                      </div>

                      {/* Bottom accent line */}
                      <div
                        className="absolute bottom-0 left-0 right-0 h-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                        style={{
                          background:
                            "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent)",
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            )}

            <style jsx>{`
              @keyframes shimmer {
                0% {
                  transform: translateX(-100%);
                }
                100% {
                  transform: translateX(100%);
                }
              }
            `}</style>
          </Grid>
        )}

        {/* Left Informative Grid Desktop Version  */}
        <Grid
          className="bukForm max-md:hidden"
          sx={{
            background: "transparent",
            borderRadius: "20px",
            padding: "32px",
            minHeight: "500px",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-4px)",
            },
          }}
        >
          {isLoadingActivities ? (
            <div className="flex justify-center items-center h-32">
              <CircularProgress size={24} sx={{ color: "#00ff88" }} />
              <Typography
                className="ml-2"
                sx={{ color: "white", fontWeight: 500 }}
              >
                Loading activities...
              </Typography>
            </div>
          ) : (
            activities.map((activity, index) => (
              <div
                key={activity._id || index}
                className={`flex w-full h-16 ${
                  index % 2 === 0 ? "bg-yellow-200" : "bg-red-200"
                }`}
                style={{
                  background:
                    index % 2 === 0
                      ? "linear-gradient(135deg, rgba(255, 235, 59, 0.9) 0%, rgba(255, 193, 7, 0.9) 100%)"
                      : "linear-gradient(135deg, rgba(255, 87, 87, 0.9) 0%, rgba(255, 107, 107, 0.9) 100%)",
                  borderRadius: "15px",
                  marginBottom: "15px",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 12px 40px rgba(0, 0, 0, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 32px rgba(0, 0, 0, 0.1)";
                }}
              >
                <div className="text-left justify-center items-center w-1/2 p-4">
                  <h2
                    style={{
                      fontWeight: 600,
                      width: "max-content",
                      color: "rgba(0, 0, 0, 0.8)",
                      fontSize: "18px",
                    }}
                  >
                    {activity.name}
                  </h2>
                </div>
                <div className="w-1/2 p-4 flex justify-end items-center">
                  <CoinsBox text={`${activity.coins_required || 0} Coins`} />
                </div>
              </div>
            ))
          )}
        </Grid>

        {/* Form Grid  */}
        <Grid className="book-form">
          <Grid className="form-heading">BOOK NOW!</Grid>

          <Grid className="details">
            <form onSubmit={handleSubmit}>
              <Grid
                display={"flex"}
                justifyContent={"space-between"}
                mb={"15px"}
                flexDirection={isMobile ? "column" : "row"}
              >
                <Grid className="input-email">
                  <label className="book-now-label">Email Address</label>
                  <input
                    name="email"
                    type="text"
                    width={"100%"}
                    placeholder="Email ID"
                    value={values.email}
                    disabled={disablevar}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={true}
                  />
                  {errorMsg && errorMsg?.email && errorMsg.email !== 0 && (
                    <Typography
                      sx={{ color: "red !important", fontSize: "13px" }}
                    >
                      {errorMsg.email}
                    </Typography>
                  )}
                </Grid>
                <Grid className="input-number">
                  <label className="book-now-label">Phone Number </label>
                  <input
                    name="phone"
                    type="text"
                    placeholder="Phone Number"
                    value={values.phone}
                    disabled={disablevar}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={true}
                  />
                  {errorMsg &&
                    errorMsg?.phone &&
                    errorMsg.phone.length !== 0 && (
                      <Typography
                        sx={{ color: "red !important", fontSize: "13px" }}
                      >
                        {errorMsg.phone}
                      </Typography>
                    )}
                </Grid>
              </Grid>

              <Grid
                display={"flex"}
                justifyContent={"space-between"}
                mb={"15px"}
                flexDirection={isMobile ? "column" : "row"}
              >
                <Grid className="input-name">
                  <label className="book-now-label">Name</label>
                  <input
                    name="name"
                    type="text"
                    placeholder="Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={true}
                  />
                </Grid>
                <Grid className="input-age-gender">
                  <Grid className="input-age">
                    <label className="book-now-label">Age</label>
                    <input
                      name="age"
                      type="number"
                      placeholder="Age"
                      value={values.age}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required={true}
                      min={1}
                      max={100}
                    />
                    {errorMsg && errorMsg?.age && errorMsg.age !== 0 && (
                      <Typography
                        sx={{ color: "red !important", fontSize: "13px" }}
                      >
                        {errorMsg.age}
                      </Typography>
                    )}
                  </Grid>

                  <Grid className="input-gender">
                    <label className="book-now-label">Gender</label>
                    <Select
                      id="gender"
                      name="gender"
                      value={
                        genderOptions.find(
                          (option) => option?.value === values?.gender,
                        ) ?? null
                      }
                      onChange={(e) => {
                        setFieldValue("gender", e?.value);
                      }}
                      onBlur={handleBlur}
                      placeholder="Select"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          background: "white",
                          height: "40px",
                        }),
                        input: (provided) => ({
                          ...provided,
                          color: "black",
                          "& input": {
                            height: "30px",
                          },
                        }),
                        ValueContainer: (provided) => ({
                          ...provided,
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          color: state.isSelected ? "white" : "black",
                        }),
                      }}
                      required={true}
                      isSearchable={false}
                      options={genderOptions}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                display={"flex"}
                justifyContent={"space-between"}
                mb={"15px"}
                width={"100%"}
              >
                <Grid className="input-package" sx={{ width: "100%" }}>
                  <label className="book-now-label">Select Coins Package</label>

                  {/* Regular coins packages selcetion */}
                  <Grid
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                      mt: "10px",
                      background: "rgba(255, 255, 255, 0.1)",
                      borderRadius: "12px",
                      padding: "15px 20px",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      backdropFilter: "blur(10px)",
                    }}
                  >
                    <Button
                      onClick={() => {
                        const sortedPackages = getSortedPackages();
                        const newIndex = Math.max(0, currentPackageIndex - 1);
                        setCurrentPackageIndex(newIndex);

                        if (sortedPackages[newIndex]) {
                          setFieldValue(
                            "package",
                            sortedPackages[newIndex]._id,
                          );
                          setFieldValue(
                            "coins",
                            sortedPackages[newIndex].coins || 0,
                          );
                          setRegularPackagePrice(
                            sortedPackages[newIndex].price || 0,
                          );
                        }
                      }}
                      disabled={currentPackageIndex === 0}
                      sx={{
                        minWidth: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        background:
                          currentPackageIndex === 0
                            ? "rgba(255, 255, 255, 0.2)"
                            : "linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%)",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "20px",
                        boxShadow:
                          currentPackageIndex === 0
                            ? "none"
                            : "0 4px 12px rgba(255, 107, 107, 0.4)",
                        "&:hover": {
                          background:
                            currentPackageIndex === 0
                              ? "rgba(255, 255, 255, 0.2)"
                              : "linear-gradient(135deg, #ff5252 0%, #f44336 100%)",
                          transform:
                            currentPackageIndex === 0 ? "none" : "scale(1.05)",
                        },
                        transition: "all 0.2s ease",
                        "&:disabled": {
                          color: "rgba(255, 255, 255, 0.5)",
                        },
                      }}
                    >
                      -
                    </Button>

                    <Grid
                      sx={{
                        flex: 1,
                        textAlign: "center",
                        background: "rgba(255, 255, 255, 0.9)",
                        borderRadius: "8px",
                        padding: "10px",
                        minHeight: "60px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#333",
                          fontWeight: "700",
                          fontSize: "16px",
                          mb: "2px",
                        }}
                      >
                        {getSortedPackages()[currentPackageIndex]?.name ||
                          "No Package"}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#666",
                          fontSize: "12px",
                          fontWeight: "500",
                        }}
                      >
                        {getSortedPackages()[currentPackageIndex]?.coins || 0}{" "}
                        Coins
                      </Typography>
                    </Grid>

                    <Button
                      onClick={() => {
                        const sortedPackages = getSortedPackages();
                        const newIndex = Math.min(
                          sortedPackages.length - 1,
                          currentPackageIndex + 1,
                        );
                        setCurrentPackageIndex(newIndex);

                        if (sortedPackages[newIndex]) {
                          setFieldValue(
                            "package",
                            sortedPackages[newIndex]._id,
                          );
                          setFieldValue(
                            "coins",
                            sortedPackages[newIndex].coins || 0,
                          );
                        }
                      }}
                      disabled={
                        currentPackageIndex >= getSortedPackages().length - 1
                      }
                      sx={{
                        minWidth: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        background:
                          currentPackageIndex >= getSortedPackages().length - 1
                            ? "rgba(255, 255, 255, 0.2)"
                            : "linear-gradient(135deg, #00ff88 0%, #00cc6a 100%)",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "20px",
                        boxShadow:
                          currentPackageIndex >= getSortedPackages().length - 1
                            ? "none"
                            : "0 4px 12px rgba(0, 255, 136, 0.4)",
                        "&:hover": {
                          background:
                            currentPackageIndex >=
                            getSortedPackages().length - 1
                              ? "rgba(255, 255, 255, 0.2)"
                              : "linear-gradient(135deg, #00cc6a 0%, #00b359 100%)",
                          transform:
                            currentPackageIndex >=
                            getSortedPackages().length - 1
                              ? "none"
                              : "scale(1.05)",
                        },
                        transition: "all 0.2s ease",
                        "&:disabled": {
                          color: "rgba(255, 255, 255, 0.5)",
                        },
                      }}
                    >
                      +
                    </Button>
                  </Grid>

                  {/* Regular Package Display */}
                  {regularPackageCoin != 0 && (
                    <Grid sx={{ mt: "20px" }}>
                      <Typography
                        sx={{
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                          mb: "10px",
                          textAlign: "center",
                        }}
                      >
                        Selected Coin Package
                      </Typography>

                      <Grid
                        key={1}
                        sx={{
                          position: "relative",
                          background:
                            "linear-gradient(135deg, rgba(255, 215, 0, 0.2) 0%, rgba(255, 193, 7, 0.1) 100%)",
                          borderRadius: "16px",
                          padding: "15px 20px",
                          border: "2px solid rgba(255, 215, 0, 0.4)",
                          backdropFilter: "blur(15px)",
                          mb: "10px",
                          boxShadow: "0 8px 24px rgba(255, 215, 0, 0.2)",
                          overflow: "hidden",
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "3px",
                            background:
                              "linear-gradient(90deg, #FFD700, #FFA500, #FFD700)",
                            animation:
                              "shimmer 2s ease-in-out infinite alternate",
                          },
                          "@keyframes shimmer": {
                            "0%": { opacity: 0.5 },
                            "100%": { opacity: 1 },
                          },
                        }}
                      >
                        <Grid
                          sx={{
                            position: "relative",
                            zIndex: 1,
                            textAlign: "center",
                          }}
                        >
                          {/* Centered Coin Display */}
                          <Grid
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "12px",
                              mb: "8px",
                            }}
                          >
                            <Grid sx={{ textAlign: "left" }}>
                              <Typography
                                sx={{
                                  color: "white",
                                  fontSize: "18px",
                                  fontWeight: "700",
                                  lineHeight: 1.2,
                                  textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
                                }}
                              >
                                {getSortedPackages()[currentPackageIndex]
                                  ?.name || "Package Name"}
                              </Typography>
                              <Typography
                                sx={{
                                  color: "#FFD700",
                                  fontSize: "16px",
                                  fontWeight: "600",
                                  textShadow:
                                    "0 2px 6px rgba(255, 215, 0, 0.4)",
                                }}
                              >
                                {regularPackageCoin} Coins
                              </Typography>
                            </Grid>
                          </Grid>

                          {/* Price Display */}
                          <Grid
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              background: "rgba(0, 0, 0, 0.4)",
                              borderRadius: "20px",
                              padding: "6px 16px",
                              border: "1px solid rgba(255, 215, 0, 0.3)",
                              gap: "6px",
                            }}
                          >
                            <Typography sx={{ fontSize: "18px" }}>
                              💰
                            </Typography>
                            <Typography
                              sx={{
                                color: "#4CAF50",
                                fontSize: "18px",
                                fontWeight: "700",
                                textShadow: "0 2px 4px rgba(76, 175, 80, 0.3)",
                              }}
                            >
                              ₹
                              {getSortedPackages()[currentPackageIndex]
                                ?.price || "Price"}
                            </Typography>
                          </Grid>
                        </Grid>

                        {/* Minimal Decorative Elements */}
                        <Grid
                          sx={{
                            position: "absolute",
                            bottom: "8px",
                            left: "8px",
                            fontSize: "12px",
                            opacity: 0.3,
                          }}
                        >
                          ✨
                        </Grid>
                        <Grid
                          sx={{
                            position: "absolute",
                            bottom: "8px",
                            right: "8px",
                            fontSize: "10px",
                            opacity: 0.3,
                          }}
                        >
                          💎
                        </Grid>
                      </Grid>
                    </Grid>
                  )}

                  {/* date and count */}
                  <Grid
                    display={"flex"}
                    marginTop={"10px"}
                    justifyContent={"space-between"}
                    mb={"15px"}
                    flexDirection={isMobile ? "column" : "row"}
                    height={isMobile ? "100px" : "70px"}
                    gap={"20px"}
                  >
                    <Grid className="input-date">
                      <label className="book-now-label">Date </label>
                      <input
                        name="date"
                        className="date-inp"
                        type="date"
                        placeholder="Date"
                        value={values.date}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required={true}
                        min={new Date().toISOString().split("T")[0]}
                      />
                    </Grid>

                    <Grid className="input-date">
                      <label className="book-now-label">Person Count</label>
                      <input
                        name="count"
                        className="date-inp"
                        type="number"
                        placeholder="Count"
                        value={values.count}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required={true}
                        min={1}
                      />
                    </Grid>
                  </Grid>

                  {/* Unlimited Packages Section */}
                  <Grid sx={{ mt: "30px" }}>
                    <label className="book-now-label">Unlimited Packages</label>

                    {/* Available Unlimited Packages */}
                    <Grid sx={{ mt: "15px" }}>
                      {unlimitedPackages.map((pkg) => (
                        <Grid
                          key={pkg.id}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            background: "rgba(255, 255, 255, 0.1)",
                            borderRadius: "12px",
                            padding: "15px 20px",
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                            backdropFilter: "blur(10px)",
                            mb: "10px",
                          }}
                        >
                          <Grid sx={{ flex: 1 }}>
                            <Typography
                              sx={{
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "600",
                                mb: "5px",
                              }}
                            >
                              {pkg.name}
                            </Typography>
                            <Typography
                              sx={{
                                color: "rgba(255, 255, 255, 0.8)",
                                fontSize: "14px",
                              }}
                            >
                              Rs {pkg.price} per package
                            </Typography>
                          </Grid>

                          <Grid
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <Button
                              onClick={() => handleUnlimitedPackageAdd(pkg)}
                              sx={{
                                minWidth: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                background:
                                  "linear-gradient(135deg, #00ff88 0%, #00cc6a 100%)",
                                color: "white",
                                fontWeight: "bold",
                                fontSize: "18px",
                                boxShadow: "0 4px 12px rgba(0, 255, 136, 0.4)",
                                "&:hover": {
                                  background:
                                    "linear-gradient(135deg, #00cc6a 0%, #00b359 100%)",
                                  transform: "scale(1.05)",
                                },
                                transition: "all 0.2s ease",
                              }}
                            >
                              +
                            </Button>
                          </Grid>
                        </Grid>
                      ))}
                    </Grid>

                    {/* Selected Unlimited Packages */}
                    {selectedUnlimitedPackages.length > 0 && (
                      <Grid sx={{ mt: "20px" }}>
                        <Typography
                          sx={{
                            color: "white",
                            fontSize: "16px",
                            fontWeight: "600",
                            mb: "10px",
                            textAlign: "center",
                          }}
                        >
                          Selected Unlimited Packages:
                        </Typography>

                        {selectedUnlimitedPackages.map((pkg) => (
                          <Grid
                            key={pkg.id}
                            sx={{
                              position: "relative",
                              background:
                                "linear-gradient(135deg, rgba(138, 43, 226, 0.2) 0%, rgba(75, 0, 130, 0.1) 100%)",
                              borderRadius: "16px",
                              padding: "15px 20px",
                              border: "2px solid rgba(138, 43, 226, 0.4)",
                              backdropFilter: "blur(15px)",
                              mb: "10px",
                              boxShadow: "0 8px 24px rgba(138, 43, 226, 0.2)",
                              overflow: "hidden",
                              "&::before": {
                                content: '""',
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                height: "3px",
                                background:
                                  "linear-gradient(90deg, #8A2BE2, #9932CC, #8A2BE2)",
                                animation:
                                  "shimmer 2s ease-in-out infinite alternate",
                              },
                              "@keyframes shimmer": {
                                "0%": { opacity: 0.5 },
                                "100%": { opacity: 1 },
                              },
                            }}
                          >
                            {/* Unlimited Icon Background */}
                            <Grid
                              sx={{
                                position: "absolute",
                                top: "-10px",
                                right: "-10px",
                                fontSize: "80px",
                                opacity: 0.08,
                                color: "#8A2BE2",
                                transform: "rotate(15deg)",
                              }}
                            >
                              ∞
                            </Grid>

                            <Grid sx={{ position: "relative", zIndex: 1 }}>
                              {/* Main Content */}
                              <Grid
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                {/* Left Section - Centered Unlimited Display */}
                                <Grid sx={{ flex: 1 }}>
                                  <Grid
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "12px",
                                      mb: "8px",
                                    }}
                                  >
                                    <Typography sx={{ fontSize: "32px" }}>
                                      ∞
                                    </Typography>
                                    <Grid sx={{ textAlign: "left" }}>
                                      <Typography
                                        sx={{
                                          color: "white",
                                          fontSize: "16px",
                                          fontWeight: "600",
                                          mb: "5px",
                                          textShadow:
                                            "0 2px 4px rgba(0, 0, 0, 0.3)",
                                        }}
                                      >
                                        {pkg.name}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          color: "green",
                                          fontSize: "14px",
                                          fontWeight: "600",
                                          textShadow:
                                            "0 2px 6px rgba(138, 43, 226, 0.4)",
                                        }}
                                      >
                                        Rs {pkg.price} × {pkg.count} = Rs{" "}
                                        {pkg.price * pkg.count}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>

                                {/* Right Section - Controls */}
                                <Grid
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                  }}
                                >
                                  <Button
                                    onClick={() =>
                                      handleUnlimitedPackageCountChange(
                                        pkg.id,
                                        pkg.count - 1,
                                      )
                                    }
                                    sx={{
                                      minWidth: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                      background:
                                        "linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%)",
                                      color: "white",
                                      fontWeight: "bold",
                                      fontSize: "18px",
                                      boxShadow:
                                        "0 4px 12px rgba(255, 107, 107, 0.4)",
                                      "&:hover": {
                                        background:
                                          "linear-gradient(135deg, #ff5252 0%, #f44336 100%)",
                                        transform: "scale(1.05)",
                                      },
                                      transition: "all 0.2s ease",
                                    }}
                                  >
                                    -
                                  </Button>

                                  <input
                                    type="number"
                                    min="0"
                                    value={pkg.count}
                                    onChange={(e) =>
                                      handleUnlimitedPackageCountChange(
                                        pkg.id,
                                        parseInt(e.target.value) || 0,
                                      )
                                    }
                                    style={{
                                      width: "60px",
                                      height: "40px",
                                      borderRadius: "8px",
                                      border:
                                        "1px solid rgba(255, 255, 255, 0.3)",
                                      background: "rgba(255, 255, 255, 0.9)",
                                      textAlign: "center",
                                      fontSize: "16px",
                                      fontWeight: "600",
                                    }}
                                  />

                                  <Button
                                    onClick={() =>
                                      handleUnlimitedPackageCountChange(
                                        pkg.id,
                                        pkg.count + 1,
                                      )
                                    }
                                    sx={{
                                      minWidth: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                      background:
                                        "linear-gradient(135deg, #00ff88 0%, #00cc6a 100%)",
                                      color: "white",
                                      fontWeight: "bold",
                                      fontSize: "18px",
                                      boxShadow:
                                        "0 4px 12px rgba(0, 255, 136, 0.4)",
                                      "&:hover": {
                                        background:
                                          "linear-gradient(135deg, #00cc6a 0%, #00b359 100%)",
                                        transform: "scale(1.05)",
                                      },
                                      transition: "all 0.2s ease",
                                    }}
                                  >
                                    +
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>

                            {/* Minimal Decorative Elements */}
                            <Grid
                              sx={{
                                position: "absolute",
                                bottom: "8px",
                                left: "8px",
                                fontSize: "12px",
                                opacity: 0.3,
                              }}
                            >
                              ✨
                            </Grid>
                            <Grid
                              sx={{
                                position: "absolute",
                                bottom: "8px",
                                right: "8px",
                                fontSize: "10px",
                                opacity: 0.3,
                              }}
                            >
                              🎯
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                  </Grid>

                  {/* Redirect Button */}
                  <Grid sx={{ mt: "20px" }}>
                    <Button
                      onClick={() => {
                        navigate("/packages");
                      }}
                      sx={{
                        width: "100%",
                        height: "50px",
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        color: "white",
                        fontWeight: "600",
                        fontSize: "16px",
                        borderRadius: "12px",
                        textTransform: "none",
                        boxShadow: "0 8px 32px rgba(102, 126, 234, 0.4)",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                          transform: "translateY(-2px)",
                          boxShadow: "0 12px 40px rgba(102, 126, 234, 0.6)",
                        },
                        transition: "all 0.3s ease",
                      }}
                    >
                      View All Packages →
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                width={"100%"}
                mb={"15px"}
                gap={"0px"}
                className="max-md:mt-[60px]"
              >
                <label className="book-now-label">Promo Code</label>
                <TextField
                  fullWidth
                  sx={{
                    background: "white",
                    borderRadius: "5px",
                    mt: "5px",
                    zIndex: 0,
                    "&:hover": {
                      "& fieldset": {
                        borderColor: "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                  placeholder="Have a promo code?"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Button onClick={() => getDiscountUsingCoupon()}>
                          Apply
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                  inputProps={{
                    sx: {
                      border: "none !important",
                      zIndex: "0 !important",
                    },
                  }}
                />
                {!!couponDiscount.message && (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "12px",
                      mt: "5px",
                    }}
                  >
                    {couponDiscount.message}
                  </Typography>
                )}
                {!!couponDiscount.discount && (
                  <Typography
                    sx={{
                      color: "green",
                      fontSize: "12px",
                      mt: "5px",
                    }}
                  >
                    Promo code applied!!
                  </Typography>
                )}
              </Grid>

              {/* coupun codes */}
              <Grid sx={{ mt: "20px" }}>
                <Button
                  onClick={() => {
                    setIsCouponModalOpen(true);
                  }}
                  sx={{
                    width: "100%",
                    height: "50px",
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    color: "white",
                    fontWeight: "600",
                    fontSize: "16px",
                    borderRadius: "12px",
                    textTransform: "none",
                    marginBottom: "15px",
                    boxShadow: "0 8px 32px rgba(102, 126, 234, 0.4)",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 12px 40px rgba(102, 126, 234, 0.6)",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  See Promo Codes →
                </Button>
              </Grid>

              {isCouponModalOpen && (
                <CouponModal
                  isOpen={isCouponModalOpen}
                  onClose={() => setIsCouponModalOpen(false)}
                />
              )}

              <Grid
                className="pricing-card"
                padding={"15px 30px"}
                marginBottom={"25px"}
                borderRadius={"5px"}
              >
                <Typography
                  fontSize={"18px"}
                  fontWeight={"500"}
                  fontFamily={"Saira"}
                  textAlign={"left"}
                  width={"100%"}
                  mb="5px"
                >
                  Price Summary
                </Typography>

                <Grid
                  width={"100%"}
                  display={"flex"}
                  gap="5px"
                  alignItems={"center"}
                  mb="10px"
                >
                  <Checkbox
                    sx={{
                      p: "0px",
                      "&.Mui-checked": {
                        color: "black",
                      },
                      position: "absolute",
                      overflow: "hidden",
                      clip: "rect(0 0 0 0)",
                      height: "1px",
                      width: "1px",
                      margin: "-1px",
                      padding: "0",
                      border: "0",
                      whiteSpace: "nowrap",
                    }}
                    onChange={(e) => {
                      setUseFuningoMoney(
                        e.target.checked
                          ? Number(values.totalfuningocoinsassigned)
                          : Number(values.totalfuningocoinsassigned),
                      );
                    }}
                    checked={usedFuningoMoney !== 0}
                    id="funingo-money"
                  />
                </Grid>

                <Grid
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"space-between"}
                >
                  <Typography>Regular Packages</Typography>
                  <Typography>
                    Rs {totalPrice - calculateUnlimitedPrice()}
                  </Typography>
                </Grid>

                {/* Show unlimited packages if any selected */}
                {selectedUnlimitedPackages.length > 0 && (
                  <>
                    {selectedUnlimitedPackages.map((pkg) => (
                      <Grid
                        key={pkg.id}
                        width={"100%"}
                        display={"flex"}
                        justifyContent={"space-between"}
                        sx={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.7)" }}
                      >
                        <Typography sx={{ fontSize: "14px" }}>
                          {pkg.name} × {pkg.count}
                        </Typography>
                        <Typography sx={{ fontSize: "14px" }}>
                          Rs {pkg.price * pkg.count}
                        </Typography>
                      </Grid>
                    ))}
                    <Grid
                      width={"100%"}
                      display={"flex"}
                      justifyContent={"space-between"}
                      sx={{ mt: "5px" }}
                    >
                      <Typography>Unlimited Packages Total</Typography>
                      <Typography>Rs {calculateUnlimitedPrice()}</Typography>
                    </Grid>
                  </>
                )}

                <Grid
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"space-between"}
                >
                  <Typography>Subtotal</Typography>
                  <Typography>Rs {totalPrice}</Typography>
                </Grid>

                <Grid
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"space-between"}
                >
                  <Typography>CGST 9% :</Typography>
                  <Typography>Rs {totalPrice * 0.09}</Typography>
                </Grid>

                <Grid
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"space-between"}
                >
                  <Typography>SGST 9% :</Typography>
                  <Typography>Rs {totalPrice * 0.09}</Typography>
                </Grid>

                {couponDiscount?.discount ? (
                  <>
                    <Grid
                      width={"100%"}
                      display={"flex"}
                      color={"green"}
                      justifyContent={"space-between"}
                    >
                      <Typography>Discount</Typography>
                      <Typography>
                        Rs{" "}
                        {(couponDiscount?.discount || 0) +
                          (totalPremiumDiscount || 0)}{" "}
                      </Typography>
                    </Grid>
                  </>
                ) : (
                  <></>
                )}

                <hr width={"100%"} />

                <Grid
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"space-between"}
                  paddingTop={"5px"}
                >
                  <Typography>Total</Typography>
                  <Typography fontWeight={"600"}>
                    Rs{" "}
                    {Math.max(
                      Math.round(
                        totalPrice -
                          (couponDiscount?.discount || 0) -
                          (totalPremiumDiscount || 0) +
                          totalPrice * 0.09 +
                          totalPrice * 0.09,
                      ),
                      0,
                    )}
                  </Typography>
                </Grid>
              </Grid>

              <Grid
                display={"flex"}
                flexDirection={"row"}
                width={"100%"}
                justifyContent={"center"}
                mb="30px"
                className="paymentButton"
              >
                <div style={{ width: "100%" }}>
                  {!values.name ? (
                    <Box
                      onClick={() => {
                        const el = document.querySelector(".book-form");
                        if (el) el.scrollIntoView({ behavior: "smooth" });
                      }}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "6px",
                        px: { xs: "16px", sm: "24px" },
                        py: "14px",
                        mx: "auto",
                        maxWidth: "500px",
                        background: "rgba(255,255,255,0.06)",
                        backdropFilter: "blur(10px)",
                        borderRadius: "16px",
                        border: "1px solid rgba(255,255,255,0.12)",
                        cursor: "pointer",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "13px", sm: "14px" },
                          fontWeight: "400",
                          color: "rgba(255,255,255,0.65)",
                          textAlign: "center",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Enter your name to book your ticket
                      </Typography>

                      <Box
                        sx={{
                          width: "40px",
                          height: "1px",
                          background: "rgba(255,255,255,0.2)",
                          my: "2px",
                        }}
                      />

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            width: "6px",
                            height: "6px",
                            borderRadius: "50%",
                            background: "#FFD700",
                            flexShrink: 0,
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: { xs: "13px", sm: "14px" },
                            fontWeight: "600",
                            color: "#FFD700",
                            textAlign: "center",
                            letterSpacing: "0.4px",
                          }}
                        >
                          For GST ticket, please visit Funingo
                        </Typography>
                        <Box
                          sx={{
                            width: "6px",
                            height: "6px",
                            borderRadius: "50%",
                            background: "#FFD700",
                            flexShrink: 0,
                          }}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <PaymentButton
                      values={prepareSubmissionValues()}
                      persons={[personsData]}
                      setPersonsData={setPersonsData}
                      handleResetBookForm={handleResetBookForm}
                      discount={couponDiscount?.discount || 0}
                      premiumDiscount={totalPremiumDiscount}
                      usedFuningoMoney={usedFuningoMoney}
                      setShowTicket={setShowTicket}
                      onClick={() => {}}
                    />
                  )}
                </div>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Booknow;

const CoinsBox = ({ text, subText }) => (
  <Box
    sx={{
      width: "140px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
    }}
  >
    <Box
      component={"img"}
      src={MoneyBg}
      alt="background"
      sx={{
        width: "130px",
        filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))",
      }}
    />
    <Box
      sx={{
        position: "absolute",
        right: "0px",
        width: { xs: "80px", md: "90px" },
      }}
    >
      <Typography
        sx={{
          color: "white",
          fontWeight: "700",
          fontSize: "12px",
          zIndex: "110",
          marginLeft: "12px",
          textAlign: "center",
          textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
        }}
      >
        {text}
      </Typography>
      {subText && (
        <Typography
          sx={{
            color: "rgba(255, 255, 255, 0.9)",
            fontWeight: "500",
            fontSize: "11px",
            zIndex: "110",
            textAlign: "center",
            textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
          }}
        >
          {subText}
        </Typography>
      )}
    </Box>
  </Box>
);
